import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService, UserIdService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class Rrs2FAService {
  constructor(
    private http: HttpClient,
    private occEndpointsService: OccEndpointsService,
    private userIdService: UserIdService
  ) {}

  sendOtp(authToken: any): Observable<any> {
    return this.userIdService.getUserId().pipe(
      switchMap((userId) => {
        return this.http.put(
          this.occEndpointsService.buildUrl('sendVerifyOtp', {
            urlParams: { userId },
          }),
          {},
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
      })
    );
  }

  verifyOtp(verificationCode: string, authToken: any): Observable<any> {
    return this.userIdService.getUserId().pipe(
      switchMap((userId) => {
        return this.http.post(
          this.occEndpointsService.buildUrl('sendVerifyOtp', {
            urlParams: { userId },
            queryParams: { verificationCode },
          }),
          {},
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
      })
    );
  }
}
